import { render, staticRenderFns } from "./EntityContacts.vue?vue&type=template&id=4d508b9f&scoped=true"
import script from "./EntityContacts.vue?vue&type=script&lang=js"
export * from "./EntityContacts.vue?vue&type=script&lang=js"
import style0 from "./EntityContacts.vue?vue&type=style&index=0&id=4d508b9f&prod&lang=scss"
import style1 from "./EntityContacts.vue?vue&type=style&index=1&id=4d508b9f&prod&lang=scss&scoped=true"
import style2 from "./EntityContacts.vue?vue&type=style&index=2&id=4d508b9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d508b9f",
  null
  
)

export default component.exports